import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {StudiewijzerlinkjesNewFacade} from '../../state/studiewijzerlinkjes/studiewijzerlinkjes.facade';

@Component({
  selector: 'app-studiewijzerlinkjes-vaksectie-platform-details-table-row-component',
  templateUrl: './studiewijzerlinkjes-vaksectie-platform-details-table-row-component.component.html',
  styleUrls: ['./studiewijzerlinkjes-vaksectie-platform-details-table-row-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudiewijzerlinkjesVaksectiePlatformDetailsTableRowComponentComponent implements OnInit {

  constructor(store: StudiewijzerlinkjesNewFacade) { }

  ngOnInit(): void {
  }

}
